module.exports = __webpack_public_path__ + "static/fcra-2020-21-q2-91619760ddf7356876b4a6a8351c0a5a.pdf";